import Cookies from '@/utils/cookie';

// 此文件是从 erp 迁移过来的框架能力

// erp 的 getSrcUrl
function getSrcUrl(url): string {
  // 针对//erp321.com规则(可带协议)
  var _ERP_RE = /^(@@)?(http:|https:)?(\/\/)src\.erp321\.com(.*)$/;
  // 针对//(bi|bi-1w|bi-2w).erp321.com规则(可带协议)
  var _BI_RE = /^(@@)?(http:|https:)?(\/\/)(bi|bi-1w|bi-2w)\.erp321\.com(.*)$/;
  // 针对/erp-web-group及后续前缀规则
  var _group_RE =
    /^(@@)?(\/erp-web-group|\/erp-components|\/erp-data|\/jht_pc)(.*)$/;
  // 供应链链接
  var _scm_RE = /^(@@)?(http:|https:)?(\/\/)(.+)\.scm121\.com(.*)$/;
  // erp321.cn
  var _cn_dev_RE = /^(@@)?(http:|https:)?(\/\/)(dev-src\.jushuitan\.com)(.*)$/;
  var _cn_test_RE =
    /^(@@)?(http:|https:)?(\/\/)(test-src\.jushuitan\.com)(.*)$/;
  var _cn_RE = /^[a-zA-Z0-9-]+\.erp321\.cn$/;
  var _protocol = window.location.protocol;
  var _hostname = window.location.hostname;
  var _url = url;

  // 供应链路径地址
  var _scm_host_RE = /^([a-zA-Z0-9-]+)\.scm121\.com$/;
  // 针对供应链下域名 (非传入url)
  var _scm_prod_RE = /^(zh|sc|gyl|pre([a-zA-Z0-9-]+)?)\.scm121\.com$/;
  var _scm_dev_RE = /^(test|uat)([a-zA-Z0-9-]+)?\.scm121\.com$/;

  var replaceMap = {
    dev: 'dev-src.jushuitan.com',
    devCN: 'dev-src.erp321.cn',
    test: 'test-src.jushuitan.com',
    testCN: 'test-src.erp321.cn',
    proxyJST: 'dailisrc.jushuitan.com',
    prodJST: 'src.jushuitan.com',
    prodERP: 'src.erp321.com',
    preERP: 'pre-src.erp321.com',
    preJST: 'pre-src.jushuitan.com',
    prodSCM: 'src.scm121.com',
    devSCM: 'dev-src.scm121.com',
  };

  function replaceFunc(spec, protocol, separator, suffix, replaceKey) {
    if (protocol) {
      return (
        (spec || '') + _protocol + separator + replaceMap[replaceKey] + suffix
      );
    } else {
      return (spec || '') + separator + replaceMap[replaceKey] + suffix;
    }
  }

  function webReplaceFunc(spec, group, left, replaceKey) {
    return (
      (spec || '') + _protocol + '//' + replaceMap[replaceKey] + group + left
    );
  }

  // /erp-web-group开头匹配 全部环境执行拼接逻辑
  if (_cn_RE.test(_hostname)) {
    if (_cn_dev_RE.test(url)) {
      _url = url.replace(
        _cn_dev_RE,
        function (str, spec, protocol, separator, domain, suffix) {
          if (protocol) {
            return (
              (spec || '') +
              _protocol +
              separator +
              'dev-src.erp321.cn' +
              suffix
            );
          } else {
            return (spec || '') + separator + 'dev-src.erp321.cn' + suffix;
          }
        },
      );
    } else if (_cn_test_RE.test(url)) {
      _url = url.replace(
        _cn_dev_RE,
        function (str, spec, protocol, separator, domain, suffix) {
          if (protocol) {
            return (
              (spec || '') +
              _protocol +
              separator +
              'test-src.erp321.cn' +
              suffix
            );
          } else {
            return (spec || '') + separator + 'test-src.erp321.cn' + suffix;
          }
        },
      );
    } else if (_group_RE.test(url)) {
      if (_ENV.isDevCN) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'devCN');
        });
      } else if (_ENV.isTestCN) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'testCN');
        });
      }
    }
    return _url;
  }

  if (_group_RE.test(url)) {
    if (_scm_host_RE.test(_hostname)) {
      if (_scm_prod_RE.test(_hostname)) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'prodSCM');
        });
      } else if (_scm_dev_RE.test(_hostname)) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'devSCM');
        });
      }
    } else {
      if (_ENV.isProdERP) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'prodERP');
        });
      } else if (_ENV.isProxyJST) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'proxyJST');
        });
      } else if (_ENV.isProdJST) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'prodJST');
        });
      } else if (_ENV.isPreERP) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'preERP');
        });
      } else if (_ENV.isPreJST || _ENV.isPreProxyJST) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'preJST');
        });
      } else if (_ENV.isTest) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'test');
        });
      } else if (_ENV.isDev) {
        _url = url.replace(_group_RE, function (str, spec, group, left) {
          return webReplaceFunc(spec, group, left, 'dev');
        });
      }
    }
  } else if (_ENV.isProd && _ERP_RE.test(url)) {
    if (_ENV.isProxyJST) {
      _url = url.replace(
        _ERP_RE,
        function (str, spec, protocol, separator, suffix) {
          return replaceFunc(spec, protocol, separator, suffix, 'proxyJST');
        },
      );
    } else if (_ENV.isProdJST) {
      _url = url.replace(
        _ERP_RE,
        function (str, spec, protocol, separator, suffix) {
          return replaceFunc(spec, protocol, separator, suffix, 'prodJST');
        },
      );
    } else if (_ENV.isPreERP) {
      _url = url.replace(
        _ERP_RE,
        function (str, spec, protocol, separator, suffix) {
          return replaceFunc(spec, protocol, separator, suffix, 'preERP');
        },
      );
    } else if (_ENV.isPreJST || _ENV.isPreProxyJST) {
      _url = url.replace(
        _ERP_RE,
        function (str, spec, protocol, separator, suffix) {
          return replaceFunc(spec, protocol, separator, suffix, 'preJST');
        },
      );
    }
  } else if (_scm_RE.test(url)) {
    if (_ENV.isPre) {
      _url = url.replace(
        _scm_RE,
        function (str, spec, protocol, separator, prefiex, suffix) {
          if (/^pre/.test(prefiex)) {
            return str;
          }
          return (
            (spec || '') +
            (protocol || '') +
            separator +
            'pre' +
            prefiex +
            '.scm121.com' +
            suffix
          );
        },
      );
    }
  } else if (_BI_RE.test(url)) {
    if (_ENV.isProxyJST) {
      _url = url.replace(
        _BI_RE,
        function (str, spec, protocol, separator, bi_env, suffix) {
          return (spec || '') + suffix;
        },
      );
    }
  }

  return _url;
}

/** 前端控制的白名单 */
const inGrayWhiteList = ({ whiteListKey, coid, env }) => {
  try {
    if (
      !whiteListKey ||
      window[whiteListKey] === undefined ||
      window[whiteListKey][env] === undefined
    ) {
      return false;
    }

    const {
      noCoids = [],
      coids = [],
      percents = [],
    } = window[whiteListKey][env];

    if (noCoids.includes(coid)) {
      return false;
    }

    if (coids.includes(coid)) {
      return true;
    }

    return percents.some((percent) => coid.toString().endsWith(percent));
  } catch (error) {}
  return false;
};

function getScmParams(url): any {
  if (url.indexOf('scm121.com') >= 0) {
    const coid = parseInt(Cookies.get('u_co_id') || '0', 10);
    if (
      inGrayWhiteList({
        whiteListKey: 'scmJumpGray',
        coid,
        env: UMI_ENV,
      })
    ) {
      window?.jmx.emit('epaas.common.syncScmToken');
      return {
        noScmT: 1,
      };
    }
  }

  return {};
}

function judgeEnv() {
  // ERP环境
  var _ENV = {
    isProd: false,
    isProdERP: false,
    isProdERP1w: false,
    isProdERP2w: false,
    isProdERP3w: false,
    isProdJST: false,
    isPre: false,
    isPreERP: false,
    isPreJST: false,
    isProxy: false,
    isProxyJST: false,
    isPreProxyJST: false,
    isTest: false,
    isTestCN: false,
    isDev: false,
    isDevCN: false,
  };

  // 框架页/环境存储判断
  var _ENVStorage = window.localStorage.getItem('_ENV');
  var _hostname = window.location.hostname || '';
  // isProd => 正式环境
  var _isProd = false;
  // isUat => 测试环境
  var _isTest = false;

  // 环境相关正则
  // 正式环境判断
  //    > 321正式环境
  var erpProd_RE = /^([a-zA-Z0-9-]+\.)?erp321\.com$/;
  //    > jushuitan正式环境
  var jstProd_RE = /^(pf|pf1)\.jushuitan\.com$/;
  //    > EPR预发
  var preERP_RE = /^(pre-[a-zA-Z0-9-]+|devjht)\.erp321\.com$/;
  //    > JST预发
  var preJST_RE = /^pre-[a-zA-Z0-9-]+\.jushuitan\.com$/;
  //    > JST代理
  var proxyJST_RE = /^(daili([a-zA-Z0-9-]+)?|do|dopre)\.jushuitan\.com$/;
  //    > 代理预发
  var proxyPreJST_RE = /^pre-[a-zA-Z0-9-]+-daili\.jushuitan\.com$/;
  // 测试开发环境
  //    > TEST  测试环境 框架页变量直接判断 非框架页使用正则
  var test_RE = /^test-[a-zA-Z0-9-]+\.jushuitan\.com$/;
  //    > TEST erp321.cn下测试环境
  var test_cn_RE = /^test-[a-zA-Z0-9-]+\.erp321\.cn$/;
  //    > dev-  开发环境
  var dev_RE = /^[a-zA-Z0-9-]+\.jushuitan\.com$/;
  //    > dev-  c.erp321.cn 特殊cn下开发环境
  var dev_cn_RE = /^((dev-[a-zA-Z0-9-]+)|c)\.erp321\.cn$/;

  // 框架页
  _isProd = UMI_ENV === 'prod' || UMI_ENV === 'pre';
  _isTest = UMI_ENV === 'test';
  // 正式环境相关判断
  if (_isProd) {
    _ENV.isProd = true;
    // 如果为正式环境 判断对应具体正式环境
    if (jstProd_RE.test(_hostname)) {
      _ENV.isProdJST = true;
    } else if (preERP_RE.test(_hostname)) {
      _ENV.isPre = true;
      _ENV.isPreERP = true;
    } else if (erpProd_RE.test(_hostname)) {
      _ENV.isProdERP = true;
      if (_hostname === 'erp321.com' || _hostname === 'www.erp321.com') {
        _ENV.isProdERP3w = true;
      } else if (_hostname === 'ww.erp321.com') {
        _ENV.isProdERP2w = true;
      } else if (_hostname === 'w.erp321.com') {
        _ENV.isProdERP1w = true;
      }
    } else if (proxyPreJST_RE.test(_hostname)) {
      _ENV.isPre = true;
      _ENV.isProxy = true;
      _ENV.isPreProxyJST = true;
    } else if (preJST_RE.test(_hostname)) {
      _ENV.isPre = true;
      _ENV.isPreJST = true;
    } else if (proxyJST_RE.test(_hostname)) {
      _ENV.isProxy = true;
      _ENV.isProxyJST = true;
    }
  } else if (_isTest) {
    if (test_cn_RE.test(_hostname)) {
      _ENV.isTestCN = true;
    } else {
      _ENV.isTest = true;
    }
  } else if (dev_RE.test(_hostname)) {
    _ENV.isDev = true;
  } else if (dev_cn_RE.test(_hostname)) {
    _ENV.isDevCN = true;
  }

  localStorage.setItem('_ENV', JSON.stringify(_ENV));
  window._ENV = _ENV;
}

export { getSrcUrl, getScmParams, judgeEnv, inGrayWhiteList };
